/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
/** Error type codes */
export var ErrorType;
(function (ErrorType) {
    ErrorType["Value1"] = "-1";
    ErrorType["Value2"] = "-2";
    ErrorType["Value3"] = "-3";
    ErrorType["Value4"] = "-4";
    ErrorType["Value5"] = "-5";
    ErrorType["Value6"] = "-6";
    ErrorType["Value7"] = "-7";
    ErrorType["Value8"] = "-8";
    ErrorType["Value9"] = "-9";
    ErrorType["Value10"] = "-10";
    ErrorType["Value11"] = "-11";
    ErrorType["Value12"] = "-12";
    ErrorType["Value13"] = "-13";
    ErrorType["Value14"] = "-14";
    ErrorType["Value15"] = "-15";
    ErrorType["Value16"] = "-16";
    ErrorType["Value17"] = "-17";
    ErrorType["Value18"] = "-18";
    ErrorType["Value19"] = "-19";
    ErrorType["Value20"] = "-20";
    ErrorType["Value21"] = "-21";
    ErrorType["Value22"] = "-22";
    ErrorType["Value23"] = "-23";
    ErrorType["Value24"] = "-24";
    ErrorType["Value25"] = "-25";
    ErrorType["Value28"] = "-28";
    ErrorType["Value26"] = "-26";
    ErrorType["Value27"] = "-27";
    ErrorType["Value29"] = "-29";
    ErrorType["Value30"] = "-30";
    ErrorType["Value31"] = "-31";
    ErrorType["Value32"] = "-32";
    ErrorType["Value33"] = "-33";
    ErrorType["Value34"] = "-34";
    ErrorType["Value35"] = "-35";
})(ErrorType || (ErrorType = {}));
/**
 * Output format
 * @default "PDF"
 */
export var FormatEnum;
(function (FormatEnum) {
    FormatEnum["PDF"] = "PDF";
    FormatEnum["DOCX"] = "DOCX";
    FormatEnum["XLSX"] = "XLSX";
    FormatEnum["XML"] = "XML";
    FormatEnum["CSV"] = "CSV";
})(FormatEnum || (FormatEnum = {}));
/**
 * Output format
 * @default "PDF"
 */
export var GenerateProgressReportParams1FormatEnum;
(function (GenerateProgressReportParams1FormatEnum) {
    GenerateProgressReportParams1FormatEnum["PDF"] = "PDF";
    GenerateProgressReportParams1FormatEnum["DOCX"] = "DOCX";
    GenerateProgressReportParams1FormatEnum["XLSX"] = "XLSX";
    GenerateProgressReportParams1FormatEnum["XML"] = "XML";
    GenerateProgressReportParams1FormatEnum["CSV"] = "CSV";
})(GenerateProgressReportParams1FormatEnum || (GenerateProgressReportParams1FormatEnum = {}));
/**
 * Output format (only CSV supported)
 * @default "CSV"
 */
export var FormatEnum1;
(function (FormatEnum1) {
    FormatEnum1["PDF"] = "PDF";
    FormatEnum1["DOCX"] = "DOCX";
    FormatEnum1["XLSX"] = "XLSX";
    FormatEnum1["XML"] = "XML";
    FormatEnum1["CSV"] = "CSV";
})(FormatEnum1 || (FormatEnum1 = {}));
/**
 * Output format (only CSV supported)
 * @default "CSV"
 */
export var GeneratePiidReportParams1FormatEnum;
(function (GeneratePiidReportParams1FormatEnum) {
    GeneratePiidReportParams1FormatEnum["PDF"] = "PDF";
    GeneratePiidReportParams1FormatEnum["DOCX"] = "DOCX";
    GeneratePiidReportParams1FormatEnum["XLSX"] = "XLSX";
    GeneratePiidReportParams1FormatEnum["XML"] = "XML";
    GeneratePiidReportParams1FormatEnum["CSV"] = "CSV";
})(GeneratePiidReportParams1FormatEnum || (GeneratePiidReportParams1FormatEnum = {}));
/**
 * Output format
 * @default "XLSX"
 */
export var FormatEnum2;
(function (FormatEnum2) {
    FormatEnum2["PDF"] = "PDF";
    FormatEnum2["DOCX"] = "DOCX";
    FormatEnum2["XLSX"] = "XLSX";
    FormatEnum2["XML"] = "XML";
    FormatEnum2["CSV"] = "CSV";
})(FormatEnum2 || (FormatEnum2 = {}));
/**
 * Output format
 * @default "XLSX"
 */
export var GenerateKult1801ExportParams1FormatEnum;
(function (GenerateKult1801ExportParams1FormatEnum) {
    GenerateKult1801ExportParams1FormatEnum["PDF"] = "PDF";
    GenerateKult1801ExportParams1FormatEnum["DOCX"] = "DOCX";
    GenerateKult1801ExportParams1FormatEnum["XLSX"] = "XLSX";
    GenerateKult1801ExportParams1FormatEnum["XML"] = "XML";
    GenerateKult1801ExportParams1FormatEnum["CSV"] = "CSV";
})(GenerateKult1801ExportParams1FormatEnum || (GenerateKult1801ExportParams1FormatEnum = {}));
/**
 * Output format
 * @default "XLSX"
 */
export var FormatEnum3;
(function (FormatEnum3) {
    FormatEnum3["PDF"] = "PDF";
    FormatEnum3["DOCX"] = "DOCX";
    FormatEnum3["XLSX"] = "XLSX";
    FormatEnum3["XML"] = "XML";
    FormatEnum3["CSV"] = "CSV";
})(FormatEnum3 || (FormatEnum3 = {}));
/**
 * Output format
 * @default "XLSX"
 */
export var GenerateKult1501ExportParams1FormatEnum;
(function (GenerateKult1501ExportParams1FormatEnum) {
    GenerateKult1501ExportParams1FormatEnum["PDF"] = "PDF";
    GenerateKult1501ExportParams1FormatEnum["DOCX"] = "DOCX";
    GenerateKult1501ExportParams1FormatEnum["XLSX"] = "XLSX";
    GenerateKult1501ExportParams1FormatEnum["XML"] = "XML";
    GenerateKult1501ExportParams1FormatEnum["CSV"] = "CSV";
})(GenerateKult1501ExportParams1FormatEnum || (GenerateKult1501ExportParams1FormatEnum = {}));
export var ImportTypeEnum;
(function (ImportTypeEnum) {
    ImportTypeEnum["NATURAL_PERSONS"] = "NATURAL_PERSONS";
    ImportTypeEnum["LEGAL_PERSONS"] = "LEGAL_PERSONS";
    ImportTypeEnum["THEMA"] = "THEMA";
})(ImportTypeEnum || (ImportTypeEnum = {}));
export var StartImport1Params1ImportTypeEnum;
(function (StartImport1Params1ImportTypeEnum) {
    StartImport1Params1ImportTypeEnum["NATURAL_PERSONS"] = "NATURAL_PERSONS";
    StartImport1Params1ImportTypeEnum["LEGAL_PERSONS"] = "LEGAL_PERSONS";
    StartImport1Params1ImportTypeEnum["THEMA"] = "THEMA";
})(StartImport1Params1ImportTypeEnum || (StartImport1Params1ImportTypeEnum = {}));
export var ImportTypeEnum1;
(function (ImportTypeEnum1) {
    ImportTypeEnum1["NATURAL_PERSONS"] = "NATURAL_PERSONS";
    ImportTypeEnum1["LEGAL_PERSONS"] = "LEGAL_PERSONS";
    ImportTypeEnum1["THEMA"] = "THEMA";
})(ImportTypeEnum1 || (ImportTypeEnum1 = {}));
export var StartImportFromNkpParams1ImportTypeEnum;
(function (StartImportFromNkpParams1ImportTypeEnum) {
    StartImportFromNkpParams1ImportTypeEnum["NATURAL_PERSONS"] = "NATURAL_PERSONS";
    StartImportFromNkpParams1ImportTypeEnum["LEGAL_PERSONS"] = "LEGAL_PERSONS";
    StartImportFromNkpParams1ImportTypeEnum["THEMA"] = "THEMA";
})(StartImportFromNkpParams1ImportTypeEnum || (StartImportFromNkpParams1ImportTypeEnum = {}));
/** @default "ERROR" */
export var SeverityEnum;
(function (SeverityEnum) {
    SeverityEnum["ERROR"] = "ERROR";
    SeverityEnum["WARNING"] = "WARNING";
})(SeverityEnum || (SeverityEnum = {}));
/** @default "ERROR" */
export var GetImportEventsParams1SeverityEnum;
(function (GetImportEventsParams1SeverityEnum) {
    GetImportEventsParams1SeverityEnum["ERROR"] = "ERROR";
    GetImportEventsParams1SeverityEnum["WARNING"] = "WARNING";
})(GetImportEventsParams1SeverityEnum || (GetImportEventsParams1SeverityEnum = {}));
/** Legal form */
export var LegalFormEnum;
(function (LegalFormEnum) {
    LegalFormEnum["LEGAL"] = "LEGAL";
    LegalFormEnum["NATURAL"] = "NATURAL";
})(LegalFormEnum || (LegalFormEnum = {}));
/** Legal form */
export var GetPersonSearchOptionsParams1LegalFormEnum;
(function (GetPersonSearchOptionsParams1LegalFormEnum) {
    GetPersonSearchOptionsParams1LegalFormEnum["LEGAL"] = "LEGAL";
    GetPersonSearchOptionsParams1LegalFormEnum["NATURAL"] = "NATURAL";
})(GetPersonSearchOptionsParams1LegalFormEnum || (GetPersonSearchOptionsParams1LegalFormEnum = {}));
export var ImportTypeEnum2;
(function (ImportTypeEnum2) {
    ImportTypeEnum2["NATURAL_PERSONS"] = "NATURAL_PERSONS";
    ImportTypeEnum2["LEGAL_PERSONS"] = "LEGAL_PERSONS";
    ImportTypeEnum2["THEMA"] = "THEMA";
})(ImportTypeEnum2 || (ImportTypeEnum2 = {}));
export var GetActiveImport2Params1ImportTypeEnum;
(function (GetActiveImport2Params1ImportTypeEnum) {
    GetActiveImport2Params1ImportTypeEnum["NATURAL_PERSONS"] = "NATURAL_PERSONS";
    GetActiveImport2Params1ImportTypeEnum["LEGAL_PERSONS"] = "LEGAL_PERSONS";
    GetActiveImport2Params1ImportTypeEnum["THEMA"] = "THEMA";
})(GetActiveImport2Params1ImportTypeEnum || (GetActiveImport2Params1ImportTypeEnum = {}));
/** @default "RELEVANCE" */
export var SortEnum;
(function (SortEnum) {
    SortEnum["RELEVANCE"] = "RELEVANCE";
    SortEnum["PUBLISHED_DESC"] = "PUBLISHED_DESC";
    SortEnum["NAME_ASC"] = "NAME_ASC";
})(SortEnum || (SortEnum = {}));
/** @default "RELEVANCE" */
export var SearchTitlesParams1SortEnum;
(function (SearchTitlesParams1SortEnum) {
    SearchTitlesParams1SortEnum["RELEVANCE"] = "RELEVANCE";
    SearchTitlesParams1SortEnum["PUBLISHED_DESC"] = "PUBLISHED_DESC";
    SearchTitlesParams1SortEnum["NAME_ASC"] = "NAME_ASC";
})(SearchTitlesParams1SortEnum || (SearchTitlesParams1SortEnum = {}));
/** @default "RELEVANCE" */
export var SortEnum1;
(function (SortEnum1) {
    SortEnum1["RELEVANCE"] = "RELEVANCE";
    SortEnum1["NAME_ASC"] = "NAME_ASC";
    SortEnum1["UPDATED_DESC"] = "UPDATED_DESC";
})(SortEnum1 || (SortEnum1 = {}));
/** @default "RELEVANCE" */
export var SearchPublishersParams1SortEnum;
(function (SearchPublishersParams1SortEnum) {
    SearchPublishersParams1SortEnum["RELEVANCE"] = "RELEVANCE";
    SearchPublishersParams1SortEnum["NAME_ASC"] = "NAME_ASC";
    SearchPublishersParams1SortEnum["UPDATED_DESC"] = "UPDATED_DESC";
})(SearchPublishersParams1SortEnum || (SearchPublishersParams1SortEnum = {}));
/** Legal form */
export var PersonLegalFormEnum;
(function (PersonLegalFormEnum) {
    PersonLegalFormEnum["LEGAL"] = "LEGAL";
    PersonLegalFormEnum["NATURAL"] = "NATURAL";
})(PersonLegalFormEnum || (PersonLegalFormEnum = {}));
/** Status of a person */
export var PersonStatusEnum;
(function (PersonStatusEnum) {
    PersonStatusEnum["PROPOSAL"] = "PROPOSAL";
    PersonStatusEnum["CONFIRMED"] = "CONFIRMED";
    PersonStatusEnum["SEARCH_FAILED"] = "SEARCH_FAILED";
})(PersonStatusEnum || (PersonStatusEnum = {}));
/** Type of collection */
export var CollectionTypeEnum;
(function (CollectionTypeEnum) {
    CollectionTypeEnum["PUBLISHER_SERIES"] = "PUBLISHER_SERIES";
    CollectionTypeEnum["SERIES"] = "SERIES";
})(CollectionTypeEnum || (CollectionTypeEnum = {}));
/** Publication status of a collection (ISSN register 008/06): LIVE, CEASED or UNKNOWN */
export var CollectionStatusEnum;
(function (CollectionStatusEnum) {
    CollectionStatusEnum["LIVE"] = "LIVE";
    CollectionStatusEnum["CEASED"] = "CEASED";
    CollectionStatusEnum["UNKNOWN"] = "UNKNOWN";
})(CollectionStatusEnum || (CollectionStatusEnum = {}));
/** Publication medium of a collection (ISSN register 007): PRINT, ONLINE or PHYSICAL_CARRIER */
export var CollectionMediumEnum;
(function (CollectionMediumEnum) {
    CollectionMediumEnum["PRINT"] = "PRINT";
    CollectionMediumEnum["ONLINE"] = "ONLINE";
    CollectionMediumEnum["PHYSICAL_CARRIER"] = "PHYSICAL_CARRIER";
})(CollectionMediumEnum || (CollectionMediumEnum = {}));
/** Legal form */
export var LegalPersonLegalFormEnum;
(function (LegalPersonLegalFormEnum) {
    LegalPersonLegalFormEnum["LEGAL"] = "LEGAL";
    LegalPersonLegalFormEnum["NATURAL"] = "NATURAL";
})(LegalPersonLegalFormEnum || (LegalPersonLegalFormEnum = {}));
/** Status of a person */
export var LegalPersonStatusEnum;
(function (LegalPersonStatusEnum) {
    LegalPersonStatusEnum["PROPOSAL"] = "PROPOSAL";
    LegalPersonStatusEnum["CONFIRMED"] = "CONFIRMED";
    LegalPersonStatusEnum["SEARCH_FAILED"] = "SEARCH_FAILED";
})(LegalPersonStatusEnum || (LegalPersonStatusEnum = {}));
/** Legal form */
export var NaturalPersonLegalFormEnum;
(function (NaturalPersonLegalFormEnum) {
    NaturalPersonLegalFormEnum["LEGAL"] = "LEGAL";
    NaturalPersonLegalFormEnum["NATURAL"] = "NATURAL";
})(NaturalPersonLegalFormEnum || (NaturalPersonLegalFormEnum = {}));
/** Status of a person */
export var NaturalPersonStatusEnum;
(function (NaturalPersonStatusEnum) {
    NaturalPersonStatusEnum["PROPOSAL"] = "PROPOSAL";
    NaturalPersonStatusEnum["CONFIRMED"] = "CONFIRMED";
    NaturalPersonStatusEnum["SEARCH_FAILED"] = "SEARCH_FAILED";
})(NaturalPersonStatusEnum || (NaturalPersonStatusEnum = {}));
/** Type of person identifier */
export var PersonIdentifierTypeEnum;
(function (PersonIdentifierTypeEnum) {
    PersonIdentifierTypeEnum["ISNI"] = "ISNI";
    PersonIdentifierTypeEnum["ORCID"] = "ORCID";
})(PersonIdentifierTypeEnum || (PersonIdentifierTypeEnum = {}));
/** Printed publication format */
export var PublicationTypePrintedPublicationsEnum;
(function (PublicationTypePrintedPublicationsEnum) {
    PublicationTypePrintedPublicationsEnum["SOFTCOVER"] = "SOFTCOVER";
    PublicationTypePrintedPublicationsEnum["HARDCOVER"] = "HARDCOVER";
})(PublicationTypePrintedPublicationsEnum || (PublicationTypePrintedPublicationsEnum = {}));
/** Status of a publisher */
export var PublisherStatusEnum;
(function (PublisherStatusEnum) {
    PublisherStatusEnum["ACTIVE"] = "ACTIVE";
    PublisherStatusEnum["CLOSING"] = "CLOSING";
    PublisherStatusEnum["CLOSED"] = "CLOSED";
})(PublisherStatusEnum || (PublisherStatusEnum = {}));
/** Registration agency */
export var PublisherRegistrationAgencyEnum;
(function (PublisherRegistrationAgencyEnum) {
    PublisherRegistrationAgencyEnum["ISBN"] = "ISBN";
    PublisherRegistrationAgencyEnum["ISMN"] = "ISMN";
})(PublisherRegistrationAgencyEnum || (PublisherRegistrationAgencyEnum = {}));
/** Registration intent */
export var PublisherRegistrationIntentEnum;
(function (PublisherRegistrationIntentEnum) {
    PublisherRegistrationIntentEnum["ONE_OFF"] = "ONE_OFF";
    PublisherRegistrationIntentEnum["CONTINUOUS"] = "CONTINUOUS";
})(PublisherRegistrationIntentEnum || (PublisherRegistrationIntentEnum = {}));
/** Type of a publisher */
export var PublisherPublisherTypeEnum;
(function (PublisherPublisherTypeEnum) {
    PublisherPublisherTypeEnum["COMMON"] = "COMMON";
    PublisherPublisherTypeEnum["SPECIAL"] = "SPECIAL";
})(PublisherPublisherTypeEnum || (PublisherPublisherTypeEnum = {}));
/** E-book/e-hudebnina format */
export var WorkSpecificationEBookFormatsEnum;
(function (WorkSpecificationEBookFormatsEnum) {
    WorkSpecificationEBookFormatsEnum["PDF"] = "PDF";
    WorkSpecificationEBookFormatsEnum["EPUB"] = "EPUB";
    WorkSpecificationEBookFormatsEnum["MOBI"] = "MOBI";
})(WorkSpecificationEBookFormatsEnum || (WorkSpecificationEBookFormatsEnum = {}));
/** Data carrier version */
export var WorkSpecificationDataCarrierVersionsEnum;
(function (WorkSpecificationDataCarrierVersionsEnum) {
    WorkSpecificationDataCarrierVersionsEnum["CD_ROM"] = "CD_ROM";
    WorkSpecificationDataCarrierVersionsEnum["DVD_ROM"] = "DVD_ROM";
})(WorkSpecificationDataCarrierVersionsEnum || (WorkSpecificationDataCarrierVersionsEnum = {}));
/** Audio book format */
export var WorkSpecificationAudioBookFormatsEnum;
(function (WorkSpecificationAudioBookFormatsEnum) {
    WorkSpecificationAudioBookFormatsEnum["ON_CARRIER"] = "ON_CARRIER";
    WorkSpecificationAudioBookFormatsEnum["WITHOUT_CARRIER"] = "WITHOUT_CARRIER";
})(WorkSpecificationAudioBookFormatsEnum || (WorkSpecificationAudioBookFormatsEnum = {}));
/** Registration agency */
export var InternationalPrefixAgencyEnum;
(function (InternationalPrefixAgencyEnum) {
    InternationalPrefixAgencyEnum["ISBN"] = "ISBN";
    InternationalPrefixAgencyEnum["ISMN"] = "ISMN";
})(InternationalPrefixAgencyEnum || (InternationalPrefixAgencyEnum = {}));
/** Status of the product */
export var PublisherPrefixStatusEnum;
(function (PublisherPrefixStatusEnum) {
    PublisherPrefixStatusEnum["ACTIVE"] = "ACTIVE";
    PublisherPrefixStatusEnum["CLOSED"] = "CLOSED";
})(PublisherPrefixStatusEnum || (PublisherPrefixStatusEnum = {}));
/** Last-used-number declaration status of a publisher prefix */
export var DeclarationStatusDto;
(function (DeclarationStatusDto) {
    DeclarationStatusDto["PENDING"] = "PENDING";
    DeclarationStatusDto["DECLARED"] = "DECLARED";
    DeclarationStatusDto["NOT_REQUIRED"] = "NOT_REQUIRED";
})(DeclarationStatusDto || (DeclarationStatusDto = {}));
/** Status of a publisher prefix range */
export var PublisherPrefixRangeStatusEnum;
(function (PublisherPrefixRangeStatusEnum) {
    PublisherPrefixRangeStatusEnum["ACTIVE"] = "ACTIVE";
    PublisherPrefixRangeStatusEnum["CLOSED"] = "CLOSED";
})(PublisherPrefixRangeStatusEnum || (PublisherPrefixRangeStatusEnum = {}));
/** Accessibility enum */
export var ProductAccessibilityEnum;
(function (ProductAccessibilityEnum) {
    ProductAccessibilityEnum["PRIVATE"] = "PRIVATE";
    ProductAccessibilityEnum["PUBLIC"] = "PUBLIC";
})(ProductAccessibilityEnum || (ProductAccessibilityEnum = {}));
/** Reason for blocking a product */
export var ProductNumberBlockRequestBlockReasonEnum;
(function (ProductNumberBlockRequestBlockReasonEnum) {
    ProductNumberBlockRequestBlockReasonEnum["UNAUTHORIZED_USE"] = "UNAUTHORIZED_USE";
    ProductNumberBlockRequestBlockReasonEnum["PRESUMED_PUBLISHED"] = "PRESUMED_PUBLISHED";
    ProductNumberBlockRequestBlockReasonEnum["USED_BEFORE_REGISTRY"] = "USED_BEFORE_REGISTRY";
    ProductNumberBlockRequestBlockReasonEnum["PRODUCT_DELETED"] = "PRODUCT_DELETED";
})(ProductNumberBlockRequestBlockReasonEnum || (ProductNumberBlockRequestBlockReasonEnum = {}));
/** Reason for blocking a product */
export var ProductNumberBlockRangeRequestBlockReasonEnum;
(function (ProductNumberBlockRangeRequestBlockReasonEnum) {
    ProductNumberBlockRangeRequestBlockReasonEnum["UNAUTHORIZED_USE"] = "UNAUTHORIZED_USE";
    ProductNumberBlockRangeRequestBlockReasonEnum["PRESUMED_PUBLISHED"] = "PRESUMED_PUBLISHED";
    ProductNumberBlockRangeRequestBlockReasonEnum["USED_BEFORE_REGISTRY"] = "USED_BEFORE_REGISTRY";
    ProductNumberBlockRangeRequestBlockReasonEnum["PRODUCT_DELETED"] = "PRODUCT_DELETED";
})(ProductNumberBlockRangeRequestBlockReasonEnum || (ProductNumberBlockRangeRequestBlockReasonEnum = {}));
/**
 * Error code
 * @example "VALIDATION_ERROR"
 */
export var ErrorDtoCodeEnum;
(function (ErrorDtoCodeEnum) {
    ErrorDtoCodeEnum["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    ErrorDtoCodeEnum["NOT_FOUND_ERROR"] = "NOT_FOUND_ERROR";
})(ErrorDtoCodeEnum || (ErrorDtoCodeEnum = {}));
/**
 * Registration agency
 * @example "ISBN"
 */
export var WipoReportParamsRegistrationAgencyEnum;
(function (WipoReportParamsRegistrationAgencyEnum) {
    WipoReportParamsRegistrationAgencyEnum["ISBN"] = "ISBN";
    WipoReportParamsRegistrationAgencyEnum["ISMN"] = "ISMN";
})(WipoReportParamsRegistrationAgencyEnum || (WipoReportParamsRegistrationAgencyEnum = {}));
/** Registration agency */
export var WipoReportDataRegistrationAgencyEnum;
(function (WipoReportDataRegistrationAgencyEnum) {
    WipoReportDataRegistrationAgencyEnum["ISBN"] = "ISBN";
    WipoReportDataRegistrationAgencyEnum["ISMN"] = "ISMN";
})(WipoReportDataRegistrationAgencyEnum || (WipoReportDataRegistrationAgencyEnum = {}));
/**
 * Registration agency
 * @default "ISBN"
 * @example "ISBN"
 */
export var ProgressReportParamsRegistrationAgencyEnum;
(function (ProgressReportParamsRegistrationAgencyEnum) {
    ProgressReportParamsRegistrationAgencyEnum["ISBN"] = "ISBN";
    ProgressReportParamsRegistrationAgencyEnum["ISMN"] = "ISMN";
})(ProgressReportParamsRegistrationAgencyEnum || (ProgressReportParamsRegistrationAgencyEnum = {}));
/**
 * Registration agency
 * @example "ISBN"
 */
export var PiidExportParamsRegistrationAgencyEnum;
(function (PiidExportParamsRegistrationAgencyEnum) {
    PiidExportParamsRegistrationAgencyEnum["ISBN"] = "ISBN";
    PiidExportParamsRegistrationAgencyEnum["ISMN"] = "ISMN";
})(PiidExportParamsRegistrationAgencyEnum || (PiidExportParamsRegistrationAgencyEnum = {}));
/**
 * Registration agency (ISBN or ISMN)
 * @example "ISBN"
 */
export var IpaReportParamsRegistrationAgencyEnum;
(function (IpaReportParamsRegistrationAgencyEnum) {
    IpaReportParamsRegistrationAgencyEnum["ISBN"] = "ISBN";
    IpaReportParamsRegistrationAgencyEnum["ISMN"] = "ISMN";
})(IpaReportParamsRegistrationAgencyEnum || (IpaReportParamsRegistrationAgencyEnum = {}));
/** Registration agency (ISBN or ISMN) */
export var IpaReportDataRegistrationAgencyEnum;
(function (IpaReportDataRegistrationAgencyEnum) {
    IpaReportDataRegistrationAgencyEnum["ISBN"] = "ISBN";
    IpaReportDataRegistrationAgencyEnum["ISMN"] = "ISMN";
})(IpaReportDataRegistrationAgencyEnum || (IpaReportDataRegistrationAgencyEnum = {}));
/** Registration agency */
export var ProductNumberCreateRequestAgencyEnum;
(function (ProductNumberCreateRequestAgencyEnum) {
    ProductNumberCreateRequestAgencyEnum["ISBN"] = "ISBN";
    ProductNumberCreateRequestAgencyEnum["ISMN"] = "ISMN";
})(ProductNumberCreateRequestAgencyEnum || (ProductNumberCreateRequestAgencyEnum = {}));
/** Reason for blocking a product */
export var ProductNumberCreateRequestBlockReasonEnum;
(function (ProductNumberCreateRequestBlockReasonEnum) {
    ProductNumberCreateRequestBlockReasonEnum["UNAUTHORIZED_USE"] = "UNAUTHORIZED_USE";
    ProductNumberCreateRequestBlockReasonEnum["PRESUMED_PUBLISHED"] = "PRESUMED_PUBLISHED";
    ProductNumberCreateRequestBlockReasonEnum["USED_BEFORE_REGISTRY"] = "USED_BEFORE_REGISTRY";
    ProductNumberCreateRequestBlockReasonEnum["PRODUCT_DELETED"] = "PRODUCT_DELETED";
})(ProductNumberCreateRequestBlockReasonEnum || (ProductNumberCreateRequestBlockReasonEnum = {}));
/** Reason for blocking a product */
export var ProductNumberBlockReasonEnum;
(function (ProductNumberBlockReasonEnum) {
    ProductNumberBlockReasonEnum["UNAUTHORIZED_USE"] = "UNAUTHORIZED_USE";
    ProductNumberBlockReasonEnum["PRESUMED_PUBLISHED"] = "PRESUMED_PUBLISHED";
    ProductNumberBlockReasonEnum["USED_BEFORE_REGISTRY"] = "USED_BEFORE_REGISTRY";
    ProductNumberBlockReasonEnum["PRODUCT_DELETED"] = "PRODUCT_DELETED";
})(ProductNumberBlockReasonEnum || (ProductNumberBlockReasonEnum = {}));
/**
 * Registration agency
 * @example "ISBN"
 */
export var ProductNumberAssignResponseAgencyEnum;
(function (ProductNumberAssignResponseAgencyEnum) {
    ProductNumberAssignResponseAgencyEnum["ISBN"] = "ISBN";
    ProductNumberAssignResponseAgencyEnum["ISMN"] = "ISMN";
})(ProductNumberAssignResponseAgencyEnum || (ProductNumberAssignResponseAgencyEnum = {}));
/**
 * Registration agency the number would be drawn from, derived from the requested primary content type (musical notation = ISMN, anything else = ISBN).
 * @example "ISMN"
 */
export var ProductNumberFeasibilityResponseAgencyEnum;
(function (ProductNumberFeasibilityResponseAgencyEnum) {
    ProductNumberFeasibilityResponseAgencyEnum["ISBN"] = "ISBN";
    ProductNumberFeasibilityResponseAgencyEnum["ISMN"] = "ISMN";
})(ProductNumberFeasibilityResponseAgencyEnum || (ProductNumberFeasibilityResponseAgencyEnum = {}));
/** Type of collection */
export var CollectionMessageTypeEnum;
(function (CollectionMessageTypeEnum) {
    CollectionMessageTypeEnum["PUBLISHER_SERIES"] = "PUBLISHER_SERIES";
    CollectionMessageTypeEnum["SERIES"] = "SERIES";
})(CollectionMessageTypeEnum || (CollectionMessageTypeEnum = {}));
/** Accessibility enum */
export var ProductAccessibilityRequestAccessibilityEnum;
(function (ProductAccessibilityRequestAccessibilityEnum) {
    ProductAccessibilityRequestAccessibilityEnum["PRIVATE"] = "PRIVATE";
    ProductAccessibilityRequestAccessibilityEnum["PUBLIC"] = "PUBLIC";
})(ProductAccessibilityRequestAccessibilityEnum || (ProductAccessibilityRequestAccessibilityEnum = {}));
/** Current import status */
export var TitleImportStatusDtoStatusEnum;
(function (TitleImportStatusDtoStatusEnum) {
    TitleImportStatusDtoStatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
    TitleImportStatusDtoStatusEnum["COMPLETED"] = "COMPLETED";
    TitleImportStatusDtoStatusEnum["FAILED"] = "FAILED";
})(TitleImportStatusDtoStatusEnum || (TitleImportStatusDtoStatusEnum = {}));
export var ImportProgressDtoStatusEnum;
(function (ImportProgressDtoStatusEnum) {
    ImportProgressDtoStatusEnum["DOWNLOADING"] = "DOWNLOADING";
    ImportProgressDtoStatusEnum["RUNNING"] = "RUNNING";
    ImportProgressDtoStatusEnum["COMPLETED"] = "COMPLETED";
    ImportProgressDtoStatusEnum["FAILED"] = "FAILED";
})(ImportProgressDtoStatusEnum || (ImportProgressDtoStatusEnum = {}));
/** Accessibility filter (PUBLIC or PRIVATE) */
export var ProductSearchCriteriaAccessibilityEnum;
(function (ProductSearchCriteriaAccessibilityEnum) {
    ProductSearchCriteriaAccessibilityEnum["PRIVATE"] = "PRIVATE";
    ProductSearchCriteriaAccessibilityEnum["PUBLIC"] = "PUBLIC";
})(ProductSearchCriteriaAccessibilityEnum || (ProductSearchCriteriaAccessibilityEnum = {}));
/** Legal form */
export var PersonSearchOptionLegalFormEnum;
(function (PersonSearchOptionLegalFormEnum) {
    PersonSearchOptionLegalFormEnum["LEGAL"] = "LEGAL";
    PersonSearchOptionLegalFormEnum["NATURAL"] = "NATURAL";
})(PersonSearchOptionLegalFormEnum || (PersonSearchOptionLegalFormEnum = {}));
export var ProductDetailDtoFormatEnum;
(function (ProductDetailDtoFormatEnum) {
    ProductDetailDtoFormatEnum["PRINT"] = "PRINT";
    ProductDetailDtoFormatEnum["PRINTED_MUSIC"] = "PRINTED_MUSIC";
    ProductDetailDtoFormatEnum["EBOOK"] = "EBOOK";
    ProductDetailDtoFormatEnum["EMUSIC"] = "EMUSIC";
    ProductDetailDtoFormatEnum["AUDIO"] = "AUDIO";
    ProductDetailDtoFormatEnum["OTHER"] = "OTHER";
})(ProductDetailDtoFormatEnum || (ProductDetailDtoFormatEnum = {}));
export var TitleSummaryDtoFormatsEnum;
(function (TitleSummaryDtoFormatsEnum) {
    TitleSummaryDtoFormatsEnum["PRINT"] = "PRINT";
    TitleSummaryDtoFormatsEnum["PRINTED_MUSIC"] = "PRINTED_MUSIC";
    TitleSummaryDtoFormatsEnum["EBOOK"] = "EBOOK";
    TitleSummaryDtoFormatsEnum["EMUSIC"] = "EMUSIC";
    TitleSummaryDtoFormatsEnum["AUDIO"] = "AUDIO";
    TitleSummaryDtoFormatsEnum["OTHER"] = "OTHER";
})(TitleSummaryDtoFormatsEnum || (TitleSummaryDtoFormatsEnum = {}));
/** Status of the product */
export var PublisherPrefixHistoryStatusEnum;
(function (PublisherPrefixHistoryStatusEnum) {
    PublisherPrefixHistoryStatusEnum["ACTIVE"] = "ACTIVE";
    PublisherPrefixHistoryStatusEnum["CLOSED"] = "CLOSED";
})(PublisherPrefixHistoryStatusEnum || (PublisherPrefixHistoryStatusEnum = {}));
/** Registration agency */
export var PublisherPrefixHistoryAgencyEnum;
(function (PublisherPrefixHistoryAgencyEnum) {
    PublisherPrefixHistoryAgencyEnum["ISBN"] = "ISBN";
    PublisherPrefixHistoryAgencyEnum["ISMN"] = "ISMN";
})(PublisherPrefixHistoryAgencyEnum || (PublisherPrefixHistoryAgencyEnum = {}));
/** Status of a publisher */
export var PublisherSearchStatusEnum;
(function (PublisherSearchStatusEnum) {
    PublisherSearchStatusEnum["ACTIVE"] = "ACTIVE";
    PublisherSearchStatusEnum["CLOSING"] = "CLOSING";
    PublisherSearchStatusEnum["CLOSED"] = "CLOSED";
})(PublisherSearchStatusEnum || (PublisherSearchStatusEnum = {}));
/** Co-edition request status */
export var CoEditionRequestStatus;
(function (CoEditionRequestStatus) {
    CoEditionRequestStatus["AWAITING_CO_PUBLISHER"] = "AWAITING_CO_PUBLISHER";
    CoEditionRequestStatus["REQUESTED"] = "REQUESTED";
    CoEditionRequestStatus["ASSIGNED"] = "ASSIGNED";
    CoEditionRequestStatus["REJECTED"] = "REJECTED";
    CoEditionRequestStatus["DECLINED_BY_CO_PUBLISHER"] = "DECLINED_BY_CO_PUBLISHER";
})(CoEditionRequestStatus || (CoEditionRequestStatus = {}));
